import { type ReactNode } from 'react';

interface CompanySectionLayoutProps {
  title: string;
  children: ReactNode;
}

export const CompanySectionLayout = ({ title, children }: CompanySectionLayoutProps) => {
  return (
    <div className="flex flex-row gap-8">
      <div className="w-1/4 flex-shrink-0">
        <h2 className="text-base font-semibold text-text">{title}</h2>
      </div>
      <div className="w-3/4 flex flex-col gap-4">{children}</div>
    </div>
  );
};
